import React from 'react';
// @ts-ignore
import styles from './WorkplaceOrWorkplaceMemberSelectItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import { WorkplaceOrWorkplaceMemberSelectValue } from './WorkplaceOrWorkplaceMemberSelect';
import WorkplaceOrWorkplaceMemberSelectWorkplaceItem from './WorkplaceOrWorkplaceMemberSelectWorkplaceItem';
import WorkplaceOrWorkplaceMemberSelectWorkplaceMemberItem from './WorkplaceOrWorkplaceMemberSelectWorkplaceMemberItem';

type WorkplaceMember = {
	id: string;
	user: {
		id: string;
		profile: {
			fullName: string;
		};
	};
	workplace: Workplace;
	hasShiftNow: boolean;
};

type Workplace = {
	id: string;
	doctorDisplayName: string;
	rootWorkplace?: {
		id: string;
		doctorDisplayName: string;
	};
};

interface WorkplaceOrWorkplaceMember {
	item: WorkplaceMember | Workplace;
}

interface WorkplaceOrWorkplaceMemberSelectItemProps {
	data: any;
	selectOption: (data: {
		id: string;
		label: string;
		item: WorkplaceMember | Workplace;
	}) => void;
}

const WorkplaceOrWorkplaceMemberSelectItem: React.FC<
	WorkplaceOrWorkplaceMemberSelectItemProps
> = ({ data, selectOption }) => {
	const { item }: WorkplaceOrWorkplaceMember = data;

	const handleSelect = (
		id: string,
		label: string,
		item: WorkplaceMember | Workplace,
	) => {
		selectOption({
			id: id,
			label: label,
			item: item,
		});
	};

	if ('user' in item) {
		return (
			<WorkplaceOrWorkplaceMemberSelectWorkplaceMemberItem
				item={item}
				onSelect={handleSelect}
			/>
		);
	}

	if ('doctorDisplayName' in item) {
		return (
			<WorkplaceOrWorkplaceMemberSelectWorkplaceItem
				item={item}
				onSelect={handleSelect}
			/>
		);
	}

	return null;
};

export default WorkplaceOrWorkplaceMemberSelectItem;
